import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Header from "./Components/Header";
import SaveJamesVision from "./Pages/VisionPage";
import Footer from "./Components/Footer";
import AboutPage from "./Pages/AboutPage";
import SaveJamesManifesto from "./Pages/ManifestoPage";
import FamousTweets from "./Components/FamousTweets";
import Videos from "./Components/Videos";

function App() {
  return (
    <Router>
      <div className="App-header ">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vision" element={<SaveJamesVision />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/manifesto" element={<SaveJamesManifesto />} />
          <Route path="/tweets" element={<FamousTweets />} />
          <Route path="/ytvideos" element={<Videos />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
